import {useUnsubscribeMutation} from '@app/redux/services/paymentService';
import {LogEvents, useSendEvent} from '@app/utils/logger';
import showNotification from '@app/utils/showNotification';
import {Form} from 'antd';
import {useTranslation} from 'react-i18next';

export const useUnsubscribeForm = () => {
  const {t} = useTranslation();
  const [form] = Form.useForm();
  const sendEvent = useSendEvent();
  const [unsubscribe, {isLoading}] = useUnsubscribeMutation();

  const onUnsubscribePlan = async () => {
    const {reason} = await form.validateFields();

    try {
      sendEvent(LogEvents.UNSUBSCRIBE_PRESS);
      await unsubscribe({reason}).unwrap();
      form.resetFields();
      showNotification(
        t('Success'),
        t('Cancellation request has been submitted.'),
        'bottomRight',
        'success',
      );
    } catch (error) {
      showNotification(
        t('Error'),
        t('An error occurred while submitting the cancellation request.'),
        'bottomRight',
        'error',
      );
    }
  };
  return {
    form,
    isLoading,
    onUnsubscribePlan,
  };
};
